import React from 'react'
import { Button } from 'syngenta-react-components'
import './Alert.scss'

const Alert = props => {

  return(
    <div className='alert'>
      <div className='alertMessage'>
        <p>{props.alertMessage}</p>
        <Button text='OK' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={props.handleDismiss}></Button>
      </div>
    </div>
  )
}

export default Alert